package Utils

//import kotlinx.datetime.*
//import java.text.SimpleDateFormat
//import java.time.LocalDate
//import java.time.format.DateTimeFormatter


import kotlinx.datetime.*
import myName
import kotlin.math.abs
import kotlin.math.min
// kotlinx-datetime 0.7 moved Instant/Clock into the stdlib (kotlin.time)
import kotlin.time.Clock
import kotlin.time.Instant

val DayOfWeek.ToIsraelWeekDay: Int
    get() {
        return when (this) {
            DayOfWeek.SUNDAY -> {
                0
            }

            DayOfWeek.MONDAY -> {
                1
            }

            DayOfWeek.TUESDAY -> {
                2
            }

            DayOfWeek.WEDNESDAY -> {
                3
            }

            DayOfWeek.THURSDAY -> {
                4
            }

            DayOfWeek.FRIDAY -> {
                5
            }

            DayOfWeek.SATURDAY -> {
                6
            }
        }
    }

@myName("DatesManipulator")
object DatesManipulator {
    fun israel_date_format_to_UTC(date: String): String {
        val splitted = date.split('-')

        return splitted.reversed().joinToString("-")
    }

    fun toStringRigthTimeLoc(date: String): String {
        return date.toString().split(" ").reversed().joinToString(" ")
    }

    fun toStringwithTime(date: String): String {
        return date.toString().split(" ").reversed().joinToString("  ")
    }

    @myName("dateIsrael")
    fun dateIsrael(date: String): String {
        return dateTimeIsrael(date).split(" ")[0]
    }

    /** Expand yy → yyyy (00–68 → 2000–2068, 69–99 → 1969–1999). */
    private fun expandTwoDigitYear(yy: Int): Int =
        if (yy <= 68) 2000 + yy else 1900 + yy

    /**
     * yyyy-MM-dd for DB/math / LocalDate.parse.
     * Accepts ISO yyyy-MM-dd, Israel dd-MM-yyyy, or dd-MM-yy.
     * Two-digit years are expanded so callers never see year=26 → 0026 via LocalDate.
     */
    @myName("normalizeToIsoDate")
    fun normalizeToIsoDate(date: String): String {
        val part = date.split(" ")[0].trim()
        val pieces = part.split("-", "/", ".")
        if (pieces.size < 3) return part
        return if (pieces[0].length == 4) {
            val y = pieces[0].toIntOrNull() ?: return part
            val year = if (y < 100) expandTwoDigitYear(y) else y
            val m = pieces[1].padStart(2, '0')
            val d = pieces[2].filter { it.isDigit() }.padStart(2, '0')
            "$year-$m-$d"
        } else {
            // Israel: dd-MM-yyyy or dd-MM-yy
            val d = pieces[0].padStart(2, '0')
            val m = pieces[1].padStart(2, '0')
            val rawY = pieces[2].filter { it.isDigit() }
            val yNum = rawY.toIntOrNull() ?: return part
            val year = when {
                rawY.length >= 4 -> yNum
                rawY.length <= 2 -> expandTwoDigitYear(yNum)
                else -> yNum
            }
            "$year-$m-$d"
        }
    }

    /** Parse either ISO or Israel display dates without throwing on format mixups. */
    private fun parseLocalDate(date: String): LocalDate =
        LocalDate.parse(normalizeToIsoDate(date))

    fun getDatesChunkes(fromDate:String,toDate:String, chunkSize:Int=3,byWeek:Boolean=false):List<Pair<String,String>>{
        val borders = if (byWeek) {
            getWeekDatesRange(fromDate, toDate)
        } else {
            getMonthDatesRange(fromDate, toDate)
        }

        val ranges = mutableListOf<Pair<String, String>>()

        var index = 0
        while (index < borders.size) {

            // נקודת ההתחלה: בפעם הראשונה זו פשוט הנקודה הראשונה,
            // אחר כך זה היום שאחרי נקודת הגבול הנוכחית
            val start = if (index == 0) borders[index] else getNextDay(borders[index])

            // אם כבר יצאנו מהטווח – אין מה להמשיך
            if (start > toDate) break

            // סוף הטווח לפי chunkSize, בלי לעבור את הגבול האחרון
            val endIndex = minOf(index + chunkSize, borders.size - 1)

            // להבטיח שלא עוברים את toDate, גם אם borders[endIndex] קצת אחרי
            val end = minOf(borders[endIndex], toDate)

            ranges += start to end

            index += chunkSize
        }

        return ranges
    }
fun getDatesChunkesOld(fromDate:String,toDate:String, chunkSize:Int=3,byWeek:Boolean=false):List<Pair<String,String>>{
        val dates = mutableListOf<Pair<String,String>>()

        val sub = if(byWeek) getWeekDatesRange(fromDate,toDate) else  getMonthDatesRange(fromDate,toDate)
        sub.forEachIndexed { index, s ->
            if(index%chunkSize==0){
                val d = (if(index==0) s else getNextDay(s))
                if(index==0 || d<toDate)
                    dates.add((if(index==0) s else getNextDay(s)) to sub[min(index+chunkSize,sub.size-1)])

    }
        }
        return dates
    }
    @myName("dateIsraelShrink")
    fun dateIsraelShrink(date: String): String {
        val splitted = normalizeToIsoDate(date).split("-")
        if (splitted.size < 3) return date
        return "${splitted[2]}-${splitted[1]}"
    }
    @myName("dateIsraelShrinkYear")
    fun dateIsraelShrinkYear(date: String): String {
        val splitted = normalizeToIsoDate(date).split("-")
        if (splitted.size < 3) return date
        return "${splitted[2]}-${splitted[1]}-${splitted[0].takeLast(2)}"
    }

    @myName("getTime")
    fun getTime(date: String): String {
        val d = date.split(" ")
        if (d.size < 2) {
            return "00:00"
        }
        val h = d[1].split(":")
        return "${h[0]}:${h[1]}"
    }

    /** Israel/display → ISO. Safe for already-ISO input (idempotent). */
    fun inverseDateIsrael(date: String): String {
        return normalizeToIsoDate(date)
    }

    /**
     * Toggle between ISO (yyyy-MM-dd) and Israel display (dd-MM-yyyy).
     * Legacy web order apps rely on this being a *toggle*:
     * `dateIsrael(dateIsrael(iso)) == iso` (modulo padding / 2-digit year expansion).
     * Making this idempotent breaks COFC login (LocalDate.parse on dd-MM-yyyy).
     */
    @myName("dateTimeIsrael")
    fun dateTimeIsrael(date: String): String {
        val dateSplit = date.split(" ")
        val part = dateSplit[0].trim()
        val pieces = part.split("-", "/", ".")
        val first = when {
            pieces.size < 3 -> part
            pieces[0].length == 4 -> {
                // ISO → Israel display
                val iso = normalizeToIsoDate(part)
                val p = iso.split("-")
                "${p[2]}-${p[1]}-${p[0]}"
            }
            else -> {
                // Israel display → ISO (the second call in the legacy toggle)
                normalizeToIsoDate(part)
            }
        }
        val second = if (dateSplit.size >= 2) " ${dateSplit[1]}" else ""

        return "$first$second"
    }

    fun toStringWithoutime(date: String): String {
        return date.toString().split(" ")[0]
    }

    fun _localDateToString(date: LocalDate): String {
        val year = date.year
        val month = date.month.ordinal + 1
        val day = date.dayOfMonth
        val printMonth = if (month < 10) "0$month" else month.toString()
        val printDay = if (day < 10) "0$day" else day.toString()
        return "$year-$printMonth-$printDay"

    }

    fun getYear(date: String): String {
        return date.split(" ")[0].split("-")[0]
    }

    fun getMonth(date: String): String {
        return date.split(" ")[0].split("-")[1]
    }

    /** True when [date] falls in a calendar month before the current local month. */
    fun isBeforeCurrentMonth(date: String): Boolean {
        val parts = date.trim().substringBefore(" ").split("-")
        if (parts.size < 2) return false
        val year = parts[0].toIntOrNull() ?: return false
        val month = parts[1].toIntOrNull() ?: return false
        val today = dateNowNoHour().split("-")
        if (today.size < 2) return false
        val curYear = today[0].toIntOrNull() ?: return false
        val curMonth = today[1].toIntOrNull() ?: return false
        return year < curYear || (year == curYear && month < curMonth)
    }
  fun getMonthStr(date: String): String {
       return  when(getMonth(date)){
            "01"->return "ינואר"
            "02"->return "פברואר"
            "03"->return "מרץ"
            "04"->return "אפריל"
            "05"->return "מאי"
            "06"->return "יוני"
            "07"->return "יולי"
            "08"->return "אוגוסט"
            "09"->return "ספטמבר"
            "10"->return "אוקטובר"
            "11"->return "נובמבר"
            "12"->return "דצמבר"
           else ->""
        }
    }

    fun getDay(date: String): String {
        return date.split(" ")[0].split("-")[2]
    }
    fun getDayOfYear(date: String): Int {
        return parseLocalDate(date).dayOfYear
    }

    // TimeZone.currentSystemDefault() bridges to the native platform APIs (NSTimeZone on iOS)
    // on every call, which is measurably expensive when called repeatedly in hot paths (e.g.
    // once per row per field while scrolling a list) — that repeated cost is what showed up as
    // "stuck"/laggy scrolling on iPhone. It's cached here since the device timezone essentially
    // never changes during a single app session.
    private var cachedZone: TimeZone? = null

    private fun localZone(): TimeZone {
        return cachedZone ?: TimeZone.currentSystemDefault().also { cachedZone = it }
    }

    fun _localDateTimeToString(date: LocalDateTime): String {
        val year = date.year
        val month = date.month.ordinal + 1
        val day = date.dayOfMonth
        val hour = date.hour
        val minute = date.minute
        val second = date.second
        val printMonth = if (month < 10) "0$month" else month.toString()
        val printDay = if (day < 10) "0$day" else day.toString()
        val printHour = if (hour < 10) "0$hour" else hour.toString()
        val printMinute = if (minute < 10) "0$minute" else minute.toString()
        val printSecond = if (second < 10) "0$second" else second.toString()
        return "$year-$printMonth-$printDay $printHour:$printMinute:$printSecond"

    }

    @myName("dateNow")
    fun dateNow(): String {
        val now: Instant = Clock.System.now()
//        val zone = TimeZone.of("Europe/Berlin")
        val today: LocalDateTime = now.toLocalDateTime(localZone())
        return _localDateTimeToString(today)


    }

    @myName("dateNowObject")
    fun dateNowObject(): LocalDateTime {
        val now: Instant = Clock.System.now()
//        val zone = TimeZone.of("Europe/Berlin")
        return now.toLocalDateTime(localZone())
    }

    @myName("dateNowNoHour")
    fun dateNowNoHour(): String {
        return dateNow().split(" ")[0]
    }

    /** Current local hour (0-23), for cutoff-time comparisons without exposing [LocalDateTime]. */
    @myName("currentHour")
    fun currentHour(): Int = dateNowObject().hour

    /** Current local minute (0-59), for cutoff-time comparisons without exposing [LocalDateTime]. */
    @myName("currentMinute")
    fun currentMinute(): Int = dateNowObject().minute

    fun firstDateOfMonthNow(): String {
        return minDay(dateNow())
    }

    fun daysDiffBetweenDates(d1: String, d2: String): Int {
        val d1 = parseLocalDate(d1)
        val d2 = parseLocalDate(d2)
        return abs(d1.daysUntil(d2))
    }
    fun monthDiffBetweenDates(d1: String, d2: String): Int {
        val d1 = parseLocalDate(d1)
        val d2 = parseLocalDate(d2)
        return abs(d1.monthsUntil(d2))
    }
    fun getWeeksInYear(year: Int): Int {
        // Dec 28 is guaranteed to be in the last ISO week
        return getWeek("$year-12-31")+1
    }
    fun weekDiffBetweenDates(d1: String, d2: String): Int {
        val date1 = parseLocalDate(d1)
        val date2 = parseLocalDate(d2)

        val week1 = getWeek(date1.toString())
        val week2 = getWeek(date2.toString())

        val year1 = date1.year
        val year2 = date2.year

        // If same year — simple
        if (year1 == year2) {
            return abs(week1 - week2)
        }

        return if (year1 < year2) {
            // Weeks remaining in the first year
            val weeksInYear1 = getWeeksInYear(year1)
            val leftInYear1 = weeksInYear1 - week1

            // Weeks passed in the second year
            val passedInYear2 = week2

            leftInYear1 + passedInYear2
        } else {
            // Reverse direction
            val weeksInYear2 = getWeeksInYear(year2)
            val leftInYear2 = weeksInYear2 - week2
            val passedInYear1 = week1

            leftInYear2 + passedInYear1
        }
    }


    @myName("minDay")
    fun minDay(date: String): String {
        val iso = normalizeToIsoDate(date)
        val splitted = iso.split("-").toMutableList()
        if (splitted.size < 3) return iso
        splitted[2] = "01"
        return splitted.joinToString("-")
    }

    @myName("minWeekDay")
    fun minWeekDay(date: String): String {

        val localDate = parseLocalDate(date)
        val dayPeriod = when (localDate.dayOfWeek) {
            DayOfWeek.SUNDAY -> {
                DatePeriod(0, 0, 0)
            }

            DayOfWeek.MONDAY -> {
                DatePeriod(0, 0, 1)
            }

            DayOfWeek.TUESDAY -> {
                DatePeriod(0, 0, 2)
            }

            DayOfWeek.WEDNESDAY -> {
                DatePeriod(0, 0, 3)
            }

            DayOfWeek.THURSDAY -> {
                DatePeriod(0, 0, 4)
            }

            DayOfWeek.FRIDAY -> {
                DatePeriod(0, 0, 5)
            }

            DayOfWeek.SATURDAY -> {
                DatePeriod(0, 0, 6)
            }
        }
        return _localDateToString(localDate.minus(dayPeriod))
    }

    @myName("maxWeekDay")
    fun maxWeekDay(date: String): String {

        val localDate = parseLocalDate(date)
        val dayPeriod = when (localDate.dayOfWeek) {
            DayOfWeek.SUNDAY -> {
                DatePeriod(0, 0, 6)
            }

            DayOfWeek.MONDAY -> {
                DatePeriod(0, 0, 5)
            }

            DayOfWeek.TUESDAY -> {
                DatePeriod(0, 0, 4)
            }

            DayOfWeek.WEDNESDAY -> {
                DatePeriod(0, 0, 3)
            }

            DayOfWeek.THURSDAY -> {
                DatePeriod(0, 0, 2)
            }

            DayOfWeek.FRIDAY -> {
                DatePeriod(0, 0, 1)
            }

            DayOfWeek.SATURDAY -> {
                DatePeriod(0, 0, 0)
            }
        }
        return _localDateToString(localDate.plus(dayPeriod))

    }

    @myName("getDayOfWeek")
    fun getDayOfWeek(date: String): Int {

        val localDate = parseLocalDate(date)
        return localDate.dayOfWeek.ordinal
    }

    @myName("getDayOfWeekIsrael")
    fun getDayOfWeekIsrael(date: String): Int {

        val localDate = parseLocalDate(date)
        return localDate.dayOfWeek.ToIsraelWeekDay
    }

    @myName("getNumberOfDaysBetweenDates")
    fun getNumberOfDaysBetweenDates(dayOfWeek: Int, dateFrom: String, dateTo: String): Int {

        val localDateFrom = parseLocalDate(dateFrom)
        val localDateTo = parseLocalDate(dateTo)
        val daysAmount = localDateFrom.daysUntil(localDateTo)
        val weeks = (daysAmount / 7).toInt()

        val dayOfWeekFrom = localDateFrom.dayOfWeek.ordinal
        val dayOfWeekTo = localDateTo.dayOfWeek.ordinal
        var weekCounter = 1
        var instancesCounter = 0
        if (dayOfWeek >= dayOfWeekFrom)
            instancesCounter += 1
        if (dayOfWeek <= dayOfWeekTo && dateFrom != dateTo)
            instancesCounter += 1
        while (weekCounter < weeks - 1) {
            instancesCounter += 1
            weekCounter += 1
        }

        return instancesCounter
    }

    @myName("getWeek")
    fun getWeek(date: String): Int {
        val localDate = parseLocalDate(date)
        val day = localDate.dayOfYear
        val weekNumber = (day / 7f).toInt()
        return weekNumber
    }

    @myName("getDayOfWeekStr")
    fun getDayOfWeekStr(date: String, full: Boolean = false): String {

        val localDate = parseLocalDate(date)
        return when (localDate.dayOfWeek) {
            DayOfWeek.SUNDAY -> {
                if (full) "ראשון" else "א"
            }

            DayOfWeek.MONDAY -> {
                if (full) "שני" else "ב"
            }

            DayOfWeek.TUESDAY -> {
                if (full) "שלישי" else "א"
            }

            DayOfWeek.WEDNESDAY -> {
                if (full) "רביעי" else "ד"
            }

            DayOfWeek.THURSDAY -> {
                if (full) "חמישי" else "ה"
            }

            DayOfWeek.FRIDAY -> {
                if (full) "שישי" else "ו"
            }

            DayOfWeek.SATURDAY -> {
                if (full) "שבת" else "ש"
            }
        }
    }

    @myName("minDayOfYear")
    fun minDayOfYear(date: String): String {
        val iso = normalizeToIsoDate(date)
        val splitted = iso.split("-").toMutableList()
        if (splitted.size < 3) return iso
        splitted[2] = "01"
        splitted[1] = "01"
        return splitted.joinToString("-")
    }

    @myName("maxDayOfYear")
    fun maxDayOfYear(date: String): String {
        val iso = normalizeToIsoDate(date)
        val splitted = iso.split("-").toMutableList()
        if (splitted.size < 3) return iso
        splitted[2] = "01"
        splitted[1] = "12"
        return maxDay(splitted.joinToString("-"))

    }

    @myName("maxDay")
    fun maxDay(date: String): String {
        return _localDateToString(parseLocalDate(minDay(date)).plus(DatePeriod(0, 1, 0)).minus(DatePeriod(0, 0, 1)))
    }

    fun analyzeTextAsDate(date: String): String {
        val now = date.split(" ")[0].split("-").toMutableList()
        return when {
            now[2].compareTo("max") == 0 -> {
                now[2] = "01"
                maxDay(now.joinToString("-"))
            }

            now[2].compareTo("min") == 0 -> {
                now[2] = "01"
                (now.joinToString("-"))
            }

            else -> {
                date
            }
        }
    }

    fun toMonthYearFromDate(date: String): String {
        var date = toStringWithoutime(date)
        return date.split("-").subList(0, 2).joinToString("-")
    }

    @myName("getNextDay")
    fun getNextDay(date: String, day: Int = 1): String {
        return _localDateToString(parseLocalDate(date).plus(DatePeriod(days = day)))

    }

    @myName("getNextOrderDay")
    fun getNextOrderDay(date: String, day: Int = 1): String {
        val curDate = getNextDay(date, day)
        val dayOfWeek = getDayOfWeekIsrael(curDate)
        if(dayOfWeek == 6)
            return getNextDay(curDate, 1)
        return curDate

    }

    @myName("getStartWeek")
    fun getStartWeek(date: String): String {
        val dayOfWeek = getDayOfWeekIsrael(date)
        return getNextDay(date, -dayOfWeek)

    }

    @myName("getEndWeek")
    fun getEndWeek(date: String): String {
        val dayOfWeek = getDayOfWeekIsrael(date)
        return getNextDay(date, 6 - dayOfWeek)

    }
    @myName("getStartOfMonth")
    fun getStartOfMonth(date: String): String {
        val d = date.split(" ")[0]
        return  "${d.split("-")[0]}-${d.split("-")[1]}-01"
    }
    @myName("getNextMonth")
    fun getNextMonth(date: String, Month: Int = 1): String {
        return _localDateToString(parseLocalDate(date).plus(DatePeriod(months = Month)))

    }

    @myName("getNextYear")
    fun getNextYear(date: String, year: Int = 1): String {
        return _localDateToString(parseLocalDate(date).plus(DatePeriod(years = year)))
    }

    @myName("getDatesRange")
    fun getDatesRange(min: String, max: String): List<String> {
        val lst: MutableSet<String> = mutableSetOf()
        var cur = min
        lst.add(min)
        var steps: Int = 0
        val diff = daysDiffBetweenDates(min, max) + 5
        while (cur != max && steps < diff) {
            steps += 1
            cur = getNextDay(cur)
            lst.add(cur)
        }
        return lst.toList()
    }
    @myName("getMonthDatesRange")
    fun getMonthDatesRange(min: String, max: String): List<String> {
        val lst: MutableSet<String> = mutableSetOf()
        var cur = min
        lst.add(min)
        var steps: Int = 0
        val diff = monthDiffBetweenDates(min, max)
        while (cur != max && steps < diff) {
            steps += 1
            cur = getNextMonth(cur)
            lst.add(cur)
        }
        lst.add(max)
        return lst.distinct().toList()
    }
    fun getWeekDatesRange(min: String, max: String): List<String> {
        val lst: MutableSet<String> = mutableSetOf()
        var cur = min
        lst.add(min)
        var steps: Int = 0
        val diff = weekDiffBetweenDates(min, max)
        while (cur != max && steps < diff) {
            steps += 1
            cur = getNextDay(cur, 7)
            lst.add(cur)
        }
        lst.add(max)
        return lst.distinct().toList()
    }
}